var map = {
	"./bbq.png": 6058,
	"./chicken.png": 5470,
	"./dips-nachos.png": 8023,
	"./enchiladas.png": 6133,
	"./entrees.png": 2947,
	"./fajitas.png": 4022,
	"./make-your-own-combo.png": 1946,
	"./seafood.png": 7864,
	"./steaks.png": 3297,
	"./tacos-grilled.png": 1363,
	"./veggie.png": 442
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4349;